import React from "react";

const LogoutIcon = ({ fill = "#4D4D4D" }) => {
  return (
    <svg
      width="1rem"
      height="1rem"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33341 10.9993H4.00008V15.166H14.0001V1.83268H4.00008V5.99935H2.33341V0.999349C2.33341 0.539116 2.70651 0.166016 3.16675 0.166016H14.8334C15.2937 0.166016 15.6667 0.539116 15.6667 0.999349V15.9993C15.6667 16.4596 15.2937 16.8327 14.8334 16.8327H3.16675C2.70651 16.8327 2.33341 16.4596 2.33341 15.9993V10.9993ZM7.33342 7.66602V5.16602L11.5001 8.49935L7.33342 11.8327V9.33268H0.666748V7.66602H7.33342Z"
        fill={fill}
      />
    </svg>
  );
};

export default LogoutIcon;
